import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";

"use strict";
$.extend(uly.actions, {
    "login_twitter": function(ev, $elt, ui) {
        uly.api.start()
            .follow("uly:users")
            .post("uly:twitter", {
                "source":"twitter"
            }).fail(function(result) {
                uly.actions.login(null, null, null, result.error);
            }).done(function(result) {
                if (result.location) {
                    window.document.location.href = result.location;
                    //window.open(result.location);
                }
                else {
                    uly.start();
                }
            });
    },
    "add_twatter_stream": function(ev, $elt, ui) {
        uly.api.start().follow("").
        ensure_page_permissions(FB).done(function(fbAuth) {
            var page_selector_model = {
                "pages":ko.observableArray([])
            };

            enumerate_facebook_pages(FB, fbAuth.authResponse.userID).done(function(result) {
                var dialog_model = {
                    "token": token,
                    "pages": $.map(result.data, function(val,idx) {
                        var page = {
                            "title": val.name,
                            "category": val.category,
                            "selected": ko.observable(false),
                            "id": val.id,
                            "description": ko.observable(null),
                            "fb_link":ko.observable("https://www.facebook.com/pages/{0}/{1}".format(val.name, val.id)),
                            "picture_uri":ko.observable(null),
                            "token":val.access_token
                        };
                        FB.api("/{0}?fields=id,name,description,about,link,picture".format(page.id), function(fb_page) {
                            console.log("fetched fb page:", fb_page, " for page:", page);
                            if (fb_page) {
                                page.description(fb_page.description || fb_page.about);
                                if (fb_page.picture && fb_page.picture.data) {
                                    page.picture_uri(fb_page.picture.data.url);
                                }
                                page.fb_link(fb_page.link);
                            }
                        });
                        return  page;
                    }),
                };
                uly.dialogs.execute(markup, { "raw_data":true, "title":_("twitter_title_associate_facebook_pages", "Associate Facebook Pages") }, dialog_model)
                    .done(function([page_data]) {
                    var to_post = $.map(page_data.pages, function(val) {
                        if (ko.unwrap(val.selected))
                            return val;
                        return null;
                    });
                    uly.api.start().follow("uly:admin").follow("uly:facebook").post(null, to_post).done(function(result) {
                        uly.utils.show_results(result);
                        uly.actions.navigateto("/admin/facebook");
                    }).fail(function(result) {
                        uly.utils.show_results(result);
                    });
                });
            });
        });
    }
});
